import { colors, typo } from '@design-system/styles'
import styled from '@emotion/styled'
import IconTextButton from 'src/component/molecules/IconTextButton'
import type { Scenario } from 'src/dto/Scenario/Scenario'
import { _mixpanelUtils } from 'src/utils/trackings/_mixpanel'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import modalService from '@/service/modal.service'
import { scenarioService } from '@/service/scenario.service'
import { openLink } from '@/utils/common'

type Props = {
  scenario: Scenario
}

const ScenarioPopup = ({ scenario }: Props) => {
  return (
    <S.ScenarioPopup>
      <div className="sub-title">{scenario.기능설명팝업.preTitle}</div>
      <div className="title">{scenario.기능설명팝업.title}</div>
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: scenario.기능설명팝업.descHTML ?? '' }}
      />
      <div className="contents">
        {scenario.기능설명팝업.type === '비디오' ? (
          <video src={scenario.기능설명팝업.resourceUrl} muted autoPlay />
        ) : (
          <img
            src={scenario.기능설명팝업.resourceUrl}
            alt={scenario.기능설명팝업.title}
            width={551}
            height={300}
          />
        )}
      </div>
      <div className="bottom">
        <_OldButton
          theme="primary"
          width={scenario.기능설명팝업.ctaButton.width}
          className="cta-button"
          onClick={() => {
            if (scenarioService.enabled) {
              scenario.기능설명팝업.ctaButton.onClick(scenario.id)
              _mixpanelUtils.uiTrack('정복_설명팝업_CTA버튼', { 단계: scenario.id })
            }
            modalService.closeModal()
          }}
        >
          {scenario.기능설명팝업.ctaButton.text}
        </_OldButton>
        {scenario.기능설명팝업.type === '비디오' && (
          <IconTextButton
            iconName="share"
            className="right-button"
            onClick={() => {
              if (scenario.기능설명팝업.resourceUrl) {
                openLink(scenario.기능설명팝업.resourceUrl)
                _mixpanelUtils.uiTrack('정복_설명팝업_동영상링크', { 단계: scenario.id })
              }
            }}
            text="동영상 링크"
          />
        )}
      </div>
    </S.ScenarioPopup>
  )
}

export default ScenarioPopup

const S = {
  ScenarioPopup: styled.div`
    width: 600px;
    padding: 24px;

    .sub-title {
      color: ${colors.blue.$300};
      font-weight: 700;
    }
    .title {
      ${typo.heading02};
      margin-top: 4px;
      font-weight: 700;
    }
    .description {
      ${typo.body01};
    }
    .contents {
      margin-top: 29px;
      video {
        width: 100%;
        height: 100%;
      }
    }
    .bottom {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 11px;
      .cta-button {
        margin: 0 auto;
      }
      .right-button {
        position: absolute;
        right: 0;
        margin-left: auto;
      }
    }
  `,
}
